import React, {memo} from 'react';

interface ConfusionMatrixHeaderProps {
    rightLabels: string[];
}

function ConfusionMatrixHeader({rightLabels}: ConfusionMatrixHeaderProps): JSX.Element {
    return (
        <div className="c-confusionMatrix__header">
            <div className="c-confusionMatrix__cell c-confusionMatrix__cell--header" />
            {rightLabels.map((rightLabel, index) => (
                <div key={index} className="c-confusionMatrix__cell c-confusionMatrix__cell--header">
                    {rightLabel}
                </div>
            ))}
        </div>
    );
}

export default memo(ConfusionMatrixHeader);
